import React, { createContext, useContext, useState, useEffect } from 'react'

import { session as sessionInstance } from '@/shared/services/session/instance'

const SessionContext = createContext()

export const useSessionContext = () => useContext(SessionContext)

export const SessionProvider = ({ session, children }) => {
  const [stateSession, setStateSession] = useState(session)

  // Antes reestabelecia a sessão pelo provider `refresh-session` do next-auth,
  // devolvendo o access token ao BFF. Sem BFF, quem re-busca é a api — e o
  // token nunca sai da memória do módulo.
  const refreshSession = async () => {
    const updated = await sessionInstance.update()
    const next = updated ? { user: updated.user } : null

    if (next) setStateSession(next)

    return next
  }

  useEffect(() => {
    setStateSession(session)
  }, [session])

  return (
    <SessionContext.Provider
      value={{
        ...stateSession,
        setSession: setStateSession,
        refreshSession
      }}
    >
      {children}
    </SessionContext.Provider>
  )
}

export const withSession = Component => {
  const WrappedComponent = props => {
    return (
      <SessionProvider>
        <Component {...props} />
      </SessionProvider>
    )
  }

  WrappedComponent.displayName = `withSession(${
    Component.displayName || Component.name
  })`

  return WrappedComponent
}
